module.exports = __webpack_public_path__ + "src/assets/hero-dragon-50.jpg";